import React from 'react';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import useReviewItems from './useReviewItems';

const ReviewItemsButton = ({
  onClick,
  ...rest
}) => {
  const {
    handleClick,
    isDisabled,
  } = useReviewItems(onClick);

  return (
    <FDPrimaryActionButton
      {...rest}
      onClick={() => {
        handleClick();
      }}
      disabled={isDisabled}
      isFullWidth
      label="Review Items"
    />
  );
};

ReviewItemsButton.defaultProps = {
};

ReviewItemsButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ReviewItemsButton;
